// Centralized configuration for the Sales Professional
export const repConfig = {
  name: "Joe Beal",
  title: "Senior Sales Consultant",
  phone: "(850) 621-7681",
  phoneClean: "8506217681",
  experience: "12+ Years Experience",
  tagline: "Personally helping families find the right vehicle since 2013.",
  photoUrl: "https://static-assets.internal.usercontent.site/conversations-assets/location/lluAawy8u0gzhlkVMFDc/contact/5H2hxERljiDrMDIfHGh9/ME5d5c53e261a91873c89c5eb5dba98bda.jpeg",
};